function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "17.84",
  height: "17.84",
  viewBox: "0 0 17.84 17.84",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.06 0H1.78A1.78 1.78 0 000 1.78V12.5a1.78 1.78 0 001.78 1.78h2.68v3.56l5.67-3.56h5.93a1.78 1.78 0 001.78-1.78V1.78A1.78 1.78 0 0016.06 0zm-2.68 8.03H9.81v3.57H8.03V8.03H4.46V6.24h3.57V2.68H9.8v3.56h3.57z"
})));